import  Vue from 'vue'
import msgboxVue from './msgbox.vue'


var msgbox=Vue.extend(msgboxVue)
var init, titulos
var devFuncion={resolve :'', reject:''}

 
var setTitulos= function(objeto){
    titulos = {titulo:objeto.titulo, confirmacion: objeto.confirmacion}
}

var accionFunction=action =>{
     if (devFuncion.resolve)
     {
        devFuncion.resolve(action)
     }
     else{
        devFuncion.resolve(reject)
     }
}

var show = function(mensaje, titulo, tipo){
      if(!init){
          init= new msgbox({el : document.createElement('div')})
      }
      document.body.appendChild(init.$el)
      init.mensaje=mensaje
      if(titulo==undefined)
      {
            if(tipo==2)
            {
                init.titulo=titulos.confirmacion
            }
            else
            {
                init.titulo=titulos.titulo 
            }
      }
      else
      {
          init.titulo=titulo
      }
      if(tipo==undefined)
        { 
            init.tipo=1
        }
      else
      { 
          init.tipo=2
        }     
      init.show()
}

var confirm=function(mensaje,titulo){
    return new Promise(function(resolve,reject){
                devFuncion.resolve=resolve
                devFuncion.reject=reject   
                show(mensaje,titulo,2)
                init.returnAccion=accionFunction
             })
          
}

export default { show, setTitulos, confirm}